<div id="jobImport">
    <div class="card vh-140 rounded-6 border-0 w-100"
        [ngClass]="activeIndex == 3 ? ' min-w-80 max-w-80':' min-w-98 max-w-98'">
        <div class="d-flex align-items-center py-14 px-24 border-bottom-2 border-gray-100 border-bottom-style-solid min-h-px-60 max-h-px-60">
            <div class="min-w-18">
                <h1 class="mb-0 fs-16 fw-semibold color-gray-900">
                    {{activeIndex == 3 ? ('master_plans.job_import_panel.page.title_validation_status' | t) :
                    ('master_plans.job_import_panel.page.title_job_import' | t)}} </h1>
            </div>
        </div>

        <div class="d-flex w-100" *ngIf="activeIndex != 3 else importJobScreen">
            <p-tabs [value]="activeIndex" orientation="vertical" class="w-100 d-flex">
                <p-tablist class="min-w-16 max-w-16 ps-24 pt-3 border-end-1 border-gray-100 border-end-style-solid">
                    <p-tab [value]="0" (onClick)="moveIndex(0)">
                        <div>Jobs</div>
                        <div class="d-flex align-items-center z-index-unset">
                            <!-- Trigger icon -->
                            <i *ngIf="totalErrorsInJobs > 0"
                                class="pi pi-info-circle fs-15 color-danger-600 cursor-pointer"
                                (mouseenter)="jobsPanel.show($event)" (mouseleave)="jobsPanel.hide()"
                                aria-label="Job errors">
                            </i>

                            <i *ngIf="totalErrorsInJobs === 0 && totalWarningsInJobs > 0"
                                class="pi pi-info-circle fs-15 color-warning-300 cursor-pointer"
                                (mouseenter)="jobsPanel.show($event)" (mouseleave)="jobsPanel.hide()"
                                aria-label="Job warnings">
                            </i>

                            <!-- Overlay panel -->
                            <p-popover #jobsPanel appendTo="body" [dismissable]="false"
                                styleClass="min-w-13 popover-dark"
                                (mouseenter)="jobsPanel.show($event)" (mouseleave)="jobsPanel.hide()">

                                <div>
                                    <div class="text-white fs-14 mb-1">
                                        Total Jobs:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalJobs }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Errors:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalErrorsInJobs }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Warnings:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalWarningsInJobs }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Success:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalSuccessInJobs }}
                                        </span>
                                    </div>
                                </div>

                            </p-popover>
                        </div>
                    </p-tab>
                    <p-tab [value]="1" (onClick)="moveIndex(1)">
                        <div>Locations</div>
                        <div class="d-flex align-items-center z-index-unset">
                            <!-- Trigger icon: errors -->
                            <i *ngIf="totalErrorsInLocations > 0"
                                class="pi pi-info-circle fs-15 color-danger-600 cursor-pointer"
                                (mouseenter)="locationsPanel.show($event)" (mouseleave)="locationsPanel.hide()"
                                aria-label="Location errors">
                            </i>

                            <!-- Trigger icon: warnings -->
                            <i *ngIf="totalErrorsInLocations === 0 && totalWarningsInLocations > 0"
                                class="pi pi-info-circle fs-15 color-warning-300 cursor-pointer"
                                (mouseenter)="locationsPanel.show($event)" (mouseleave)="locationsPanel.hide()"
                                aria-label="Location warnings">
                            </i>

                            <!-- Overlay panel -->
                            <p-popover #locationsPanel appendTo="body" [dismissable]="false"
                                styleClass="min-w-13 popover-dark"
                                (mouseenter)="locationsPanel.show($event)" (mouseleave)="locationsPanel.hide()">

                                <div>
                                    <div class="text-white fs-14 mb-1">
                                        Total Locations:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalLocations }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Errors:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalErrorsInLocations }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Warnings:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalWarningsInLocations }}
                                        </span>
                                    </div>

                                    <div class="text-white fs-14 mb-1">
                                        Success:
                                        <span class="fs-14 fw-semibold text-white">
                                            {{ totalSuccessInLocations }}
                                        </span>
                                    </div>
                                </div>

                            </p-popover>
                        </div>
                    </p-tab>
                </p-tablist>

                <p-tabpanels class="p-0 overflow-auto overflow-x-hidden flex-auto">
                    <p-tabpanel [value]="0">
                        <ng-container *ngIf="jobs">
                            <div class="vh-267">
                            <ng-container *ngIf="isJobFilterApplied">
                                <div class="d-flex gap-6 align-items-center flex-wrap px-3 py-2">
                                    <label class="fs-14 fw-semibold text-white">Filters Applied:</label>
                                    <!-- <div 
                                                class="badge py-px-6 text-white bg-gray-300 d-inline-flex align-items-center justify-content-between gap-10 fs-12">
                                                <div class="fw-regular max-w-9 text-truncate lh-1-3"
                                                    title="Erros, Warnings"><span class="text-capitalize">Status:</span> Erros, Warnings</div>
                                                <span class="close"><i
                                                        class="fa-regular fa-circle-xmark cursor-pointer fs-13 hover-gray-600 color-gray-700"></i></span>
                                            </div> -->
                                    <ng-container *ngFor="let filter of appliedFiltersJobs; let i = index">
                                        <p-chip [label]="filter.Key + ': ' + filter.Value"
                                            removable="true" (onRemove)="resetJobFilter(i)"></p-chip>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <p-table
                                [styleClass]="isJobFilterApplied ? 'datawrapper-vh-378':'datawrapper-vh-335'" showtableHeaderBg
                                showGridlines [value]="jobs" [paginator]="true" appendTo="body"
                                [rows]="10" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [rowsPerPageOptions]="[10, 50, 100, 500, 5000]" [customSort]="true">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="d-flex align-items-center text-nowrap gap-1" pSortableColumn="name">
                                            <p-sortIcon field="name" class="icon-me-2 icon-flex"></p-sortIcon>Status

                                            <div class="d-inline-block position-relative">

                                                <!-- Trigger button (icon only) -->
                                                <span *ngIf="jobStatusSelected > 0" class="position-absolute end-n10 bg-danger-600 text-white fs-8 width-px-14 height-px-14 rounded-circle
           d-flex justify-content-center align-items-center z-index-1">
                                                    {{ jobStatusSelected }}
                                                </span>

                                                <!-- PrimeNG button -->
                                                <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                    ripple="false" (onClick)="openFilterPopover(filterPanel, $event)"
                                                    aria-label="Apply Filter">
                                                </p-button>

                                                <!-- Overlay panel -->
                                                <p-popover #filterPanel appendTo="body" styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                    <!-- Header -->
                                                    <div class="py-10 px-12">

                                                        <!-- Checkbox list -->
                                                        <ul class="list-unstyled px-0 mb-0 max-h-10 min-h-6 overflow-y-auto">
                                                            <li class="py-px-6"
                                                                *ngFor="let item of filterJobs.status; let i = index">

                                                                <div class="d-flex align-items-center gap-1">
                                                                    <p-checkbox class="d-inline-flex"
                                                                        [(ngModel)]="item.checked" [binary]="true"
                                                                        inputId="chkbox-{{ item.id }}">
                                                                    </p-checkbox>

                                                                    <label for="chkbox-{{ item.id }}" class="fs-14">
                                                                        {{ item.name }}
                                                                    </label>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <!-- Footer -->
                                                    <div
                                                        class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                        <p-button type="button"
                                                            variant="text" severity="secondary" size="small"
                                                            (onClick)="resetJobFilterField('status'); filterPanel.hide()"
                                                            label="{{ 'common.actions.buttons.reset' | t }}">
                                                        </p-button>

                                                        <p-button type="button"
                                                            size="small"
                                                            (onClick)="applyJobsFilter(); filterPanel.hide()" label="{{ 'common.actions.buttons.apply' | t }}">
                                                        </p-button>

                                                    </div>

                                                </p-popover>
                                            </div>

                                        </th>
                                        <th class="text-nowrap">
                                            <div class=" d-flex align-items-center">
                                                JOB ID

                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only, no ripple, no chrome) -->
                                                    <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary" ripple="false"
                                                        (onClick)="openFilterPopover(jobIdFilterPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #jobIdFilterPanel appendTo="body"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Content -->
                                                        <div class="py-10 px-12">
                                                            

                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'new_edit_master_plan.job_import_panel.job_id' | t }}
                                                                </label>

                                                                <input pInputText type="text" class="w-100"
                                                                    [(ngModel)]="filterJobs.jobID"
                                                                    placeholder="{{ 'new_edit_master_plan.job_import_panel.job_id.placeholder' | t }}">
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetJobFilterField('jobid'); jobIdFilterPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t}}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyJobsFilter(); jobIdFilterPanel.hide()" label="{{ 'common.actions.buttons.apply' | t}}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>

                                            </div>
                                        </th>
                                        <th class="text-nowrap">
                                            <div class=" d-flex align-items-center">
                                                Start Location
                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only, no ripple) -->
                                                    <p-button type="button" icon="pi pi-filter" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                        ripple="false" (onClick)="openFilterPopover(nameFilterPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #nameFilterPanel appendTo="body"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Header / Content -->
                                                        <div class="py-10 px-12">
                                                            

                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'common.fields.common.name' | t }}
                                                                </label>

                                                                <input pInputText type="text" class="w-100"
                                                                    [(ngModel)]="filterJobs.startlocation"
                                                                    placeholder="{{ 'common.fields.common.enter_keyword_to_search' | t }}">
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetJobFilterField('startlocation'); nameFilterPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t }}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyJobsFilter(); nameFilterPanel.hide()" label="{{ 'common.actions.buttons.apply' | t }}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>

                                            </div>
                                        </th>
                                        <th class="text-nowrap">
                                            <div class=" d-flex align-items-center">
                                                End Location
                                                <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                    ripple="false" (onClick)="openFilterPopover(endLocationFilterPanel, $event)"
                                                    aria-label="Apply Filter">
                                                </p-button>

                                                <!-- Overlay panel -->
                                                <p-popover #endLocationFilterPanel appendTo="body"
                                                    styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                    <!-- Header / Content -->
                                                    <div class="py-10 px-12">

                                                        <div>
                                                            <label class="form-label fs-12">
                                                                {{ 'common.fields.common.name' | t }}
                                                            </label>

                                                            <input pInputText type="text" class="w-100"
                                                                [(ngModel)]="filterJobs.endlocation"
                                                                placeholder="{{ 'common.fields.common.enter_keyword_to_search' | t }}">
                                                        </div>
                                                    </div>

                                                    <!-- Footer -->
                                                    <div
                                                        class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                        <p-button type="button"
                                                           variant="text" severity="secondary" size="small"
                                                            (onClick)="resetJobFilterField('endlocation'); endLocationFilterPanel.hide()"
                                                            label="{{ 'common.actions.buttons.reset' | t }}">
                                                        </p-button>

                                                        <p-button type="button"
                                                            size="small"
                                                            (onClick)="applyJobsFilter(); endLocationFilterPanel.hide()" label="{{ 'common.actions.buttons.apply' | t }}">
                                                        </p-button>

                                                    </div>

                                                </p-popover>
                                            </div>
                                        </th>
                                        <th class="text-nowrap">Start - End Time </th>
                                        <th class="text-nowrap">
                                            <div class=" d-flex align-items-center">
                                                Distribution
                                                <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                    ripple="false" (onClick)="openFilterPopover(distributionPanel, $event)"
                                                    aria-label="Apply Filter">
                                                </p-button>

                                                <!-- Overlay panel -->
                                            <p-popover #distributionPanel appendTo="body" [dismissable]="true" styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">
                                                <div class="py-10 px-12">

                                                        <div>
                                                            <label class="form-label fs-12">
                                                                {{ 'new_edit_master_plan.job_import_panel.select_distribution_area.label' | t }}
                                                            </label>

                                                            <p-dropdown [(ngModel)]="selectedDistribution"
                                                                [options]="distributionList" optionLabel="name"
                                                                placeholder="{{ 'new_edit_master_plan.job_import_panel.select_distribution_area.placeholder' | t }}"
                                                                panelStyleClass="p-dropdown-panel-sm"
                                                                styleClass="p-dropdown-sm w-100">
                                                            </p-dropdown>
                                                        </div>
                                                    </div>

                                                    <!-- Footer -->
                                                    <div
                                                        class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                        <p-button type="button"
                                                            variant="text" severity="secondary" size="small"
                                                            (onClick)="resetJobFilterField('distribution'); distributionPanel.hide()"
                                                            label="{{ 'common.actions.buttons.reset' | t}}">
                                                        </p-button>

                                                        <p-button type="button"
                                                            size="small"
                                                            (onClick)="applyJobsFilter(); distributionPanel.hide()"
                                                            label="{{ 'common.actions.buttons.apply' | t  }}">
                                                        </p-button>

                                                    </div>

                                                </p-popover>
                                            </div>
                                        </th>
                                        <th class="">
                                            <div class=" d-flex align-items-center">
                                                Vehicle
                                                <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                    ripple="false" (onClick)="openFilterPopover(vehiclePanel, $event)"
                                                    aria-label="Apply Filter">
                                                </p-button>

                                                <!-- Overlay panel -->
                                            <p-popover #vehiclePanel appendTo="body" [dismissable]="true" styleClass="p-0 min-w-16 max-w-16 popover-content-p-0"> 
                                                <div class="py-10 px-12">

                                                        <div>
                                                            <label class="form-label fs-12">
                                                                {{ 'new_edit_master_plan.job_import_panel.select_vehicle_type' | t }}
                                                            </label>

                                                            <p-dropdown [(ngModel)]="selectedVehicle"
                                                                [options]="vehicles" optionLabel="name"
                                                                placeholder=" {{ 'new_edit_master_plan.job_import_panel.select_vehicle.placeholder' | t }}"
                                                                panelStyleClass="p-dropdown-panel-sm"
                                                                styleClass="p-dropdown-sm w-100"
                                                                (onChange)="onVehicleChange($event)">
                                                            </p-dropdown>
                                                        </div>
                                                    </div>

                                                    <!-- Footer -->
                                                    <div
                                                        class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                        <p-button type="button"
                                                            variant="text" severity="secondary" size="small"
                                                            (onClick)="resetJobFilterField('vehicle'); vehiclePanel.hide()"
                                                            label="{{ 'common.actions.buttons.reset' | t }}">
                                                        </p-button>

                                                        <p-button type="button"
                                                            size="small"
                                                            (onClick)="applyJobsFilter(); vehiclePanel.hide()"
                                                            label="{{ 'common.actions.buttons.apply' | t}}">
                                                        </p-button>

                                                    </div>

                                                </p-popover>
                                            </div>
                                        </th>
                                        <th class="">Problem</th>
                                        <th class="text-nowrap">Problem Located At</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-job>
                                    <tr>
                                        <td class="text-center">
                                            <i class="fa fs-17 cursor-default"
                                                [ngClass]="[job.jobStatus == 1 ? 'fa-times-circle color-danger-600':'', job.jobStatus == 2 ? 'fa-check-circle color-warning-300':'', job.jobStatus == 3 ? 'fa-check-circle color-success-500':'']"></i>
                                        </td>
                                        <td>{{ job.jobId }}</td>
                                        <td>
                                            <div *ngIf="job.startLocationName else noStartLocation">
                                                <div class="fw-semibold color-gray-800 mb-1">{{
                                                    job.startLocationName }}</div>
                                                <div class="mb-1">{{ job.startAddress }}</div>
                                                <div class="mb-1">{{ job.startLocationPostalCode }} - {{
                                                    job.startLocationCity }}
                                                </div>
                                                <div class="mb-1">{{ job.startLocationCountry }}</div>
                                            </div>
                                            <ng-template #noStartLocation>
                                                --
                                            </ng-template>
                                        </td>
                                        <td>
                                            <div *ngIf="job.endLocationName else noEndLocation">
                                                <div class="fw-semibold color-gray-800 mb-1">{{
                                                    job.endLocationName
                                                    }}</div>
                                                <div class="mb-1">{{ job.endAddress }}</div>
                                                <div class="mb-1">{{ job.endLocationPostalCode }} - {{
                                                    job.endLocationCity }}
                                                </div>
                                                <div class="mb-1">{{ job.endLocationCountry }}</div>
                                            </div>
                                            <ng-template #noEndLocation>
                                                --
                                            </ng-template>
                                        </td>
                                        <td>{{ job.startTime }} - {{ job.endTime }}</td>
                                        <td>{{ job.distributionAreaName }}</td>
                                        <td>{{ job.vehicleName }}</td>
                                        <td>{{ job.problem }}</td>
                                        <td>{{ job.problemLocatedAt }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <div class="empty-state grid">
                                        <div class="illustration">
                                            <svg class="width-11 height-8">
                                                <use xlink:href="#empty-state-file"></use>
                                            </svg>
                                        </div>

                                        <p class="fs-16 color-gray-900 p-0">
                                            No record found!
                                        </p>
                                    </div>
                                </ng-template>

                            </p-table>
                            </div>
                        </ng-container>
                    </p-tabpanel>
                    <p-tabpanel [value]="1">
                        <ng-container *ngIf="locations">
                            <div class="vh-267">
                            <ng-container *ngIf="isLocationFilterApplied">
                                <div class="d-flex gap-6 align-items-center flex-wrap px-3 py-2">
                                    <label class="fs-14 fw-semibold color-gray-800">Filters Applied:</label>
                                    <ng-container *ngFor="let filter of appliedFiltersLocations; let i = index">
                                        <p-chip 
                                            [label]="filter.Key + ': ' + filter.Value" removable="true"
                                            (onRemove)="resetLocationFilter(i)"></p-chip>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <p-table
                                [styleClass]="isLocationFilterApplied ? 'datawrapper-vh-378':'datawrapper-vh-335'" showtableHeaderBg
                                showGridlines [value]="locations " [paginator]="true" [rows]="10"
                                [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [rowsPerPageOptions]="[10, 50, 100, 500, 5000]" [customSort]="true">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="d-flex align-items-center gap-1 text-nowrap" pSortableColumn="name">
                                            <p-sortIcon field="name" class="icon-me-2 icon-flex"></p-sortIcon>Status


                                            <div class="d-inline-block position-relative">

                                                <!-- Badge -->
                
                                                <p-badge badgeSize="small" class="position-absolute end-n20 z-index-99" severity="danger" *ngIf="locationStatusSelected > 0" value="{{ locationStatusSelected }}" />

                                                <!-- PrimeNG trigger button -->
                                                <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                    ripple="false" (onClick)="openFilterPopover(locationStatusPanel, $event)"
                                                    aria-label="Apply Filter">
                                                </p-button>

                                                <!-- Overlay panel -->
                                                <p-popover #locationStatusPanel appendTo="body"
                                                    styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                    <!-- Content -->
                                                    <div class="py-10 px-12">

                                                        <ul class="list-unstyled px-0 mb-0 max-h-10 min-h-6 overflow-y-auto">
                                                            <li class="py-px-6"
                                                                *ngFor="let item of filterLocations.status">

                                                                <div class="d-flex align-items-center gap-1">
                                                                    <p-checkbox [(ngModel)]="item.checked"
                                                                        [binary]="true"
                                                                        inputId="location-status-{{ item.id }}">
                                                                    </p-checkbox>

                                                                    <label for="location-status-{{ item.id }}"
                                                                        class="fs-14">
                                                                        {{ item.name }}
                                                                    </label>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <!-- Footer -->
                                                    <div
                                                        class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                        <p-button type="button"
                                                            variant="text" severity="secondary" size="small"
                                                            (onClick)="resetLocationFilterField('status'); locationStatusPanel.hide()"
                                                            label="{{ 'common.actions.buttons.reset' | t}}">
                                                        </p-button>

                                                        <p-button type="button"
                                                            size="small"
                                                            (onClick)="applyLocationsFilter(); locationStatusPanel.hide()"
                                                            label="{{ 'common.actions.buttons.apply' | t }}">
                                                        </p-button>

                                                    </div>

                                                </p-popover>
                                            </div>

                                        </th>
                                        <th class="">
                                            <div class="d-flex align-items-center text-nowrap">
                                                JOB ID
                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only) -->
                                                    <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                        ripple="false" (onClick)="openFilterPopover(locationJobIdPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #locationJobIdPanel appendTo="body"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Content -->
                                                        <div class="py-10 px-12">
                                                            

                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'new_edit_master_plan.job_import_panel.job_id' | t}}
                                                                </label>

                                                                <input pInputText type="text" class="w-100"
                                                                    [(ngModel)]="filterLocations.jobID"
                                                                    placeholder="{{ 'new_edit_master_plan.job_import_panel.job_id.placeholder' | t }}">
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetLocationFilterField('jobid'); locationJobIdPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t}}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyLocationsFilter(); locationJobIdPanel.hide()"
                                                                label="{{ 'common.actions.buttons.apply' | t }}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>
                                            </div>

                                        </th>
                                        <th class="">
                                            <div class="d-flex align-items-center text-nowrap">
                                                Location ID
                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only) -->
                                                    <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                        ripple="false" (onClick)="openFilterPopover(locationIdFilterPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #locationIdFilterPanel appendTo="body"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Content -->
                                                        <div class="py-10 px-12">
                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'new_edit_master_plan.job_import_panel.label.enter_location_id' | t }}
                                                                </label>

                                                                <input pInputText type="text" class="w-100"
                                                                    [(ngModel)]="filterLocations.locationid"
                                                                    placeholder="{{ 'new_edit_master_plan.job_import_panel.placeholder.enter_location_id' | t }}">
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetLocationFilterField('locationid'); locationIdFilterPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t }}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyLocationsFilter(); locationIdFilterPanel.hide()"
                                                                label="{{ 'common.actions.buttons.apply' | t }}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="">
                                            <div class="d-flex align-items-center text-nowrap">
                                                Location Address
                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only) -->
                                                    <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                        ripple="false" (onClick)="openFilterPopover(locationAddressPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #locationAddressPanel appendTo="body"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Content -->
                                                        <div class="py-10 px-12">
                                                            

                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'common.fields.common.name' | t }}
                                                                </label>

                                                                <input pInputText type="text" class="w-100"
                                                                    [(ngModel)]="filterLocations.locationaddress"
                                                                    placeholder="{{ 'common.fields.common.enter_keyword_to_search' | t }}">
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetLocationFilterField('locationaddress'); locationAddressPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t }}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyLocationsFilter(); locationAddressPanel.hide()"
                                                                label="{{ 'common.actions.buttons.apply' | t }}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="text-nowrap">Service hours from - to</th>
                                        <th class="text-nowrap">
                                            <div class="d-flex align-items-center">
                                                Products
                                                <div class="d-inline-block position-relative">

                                                    <!-- PrimeNG trigger button (icon-only) -->
                                                    <p-button type="button" icon="pi pi-filter fs-12" class="ms-2" styleClass="width-px-24 height-px-24"
                                                    variant="text" size="small" [rounded]="true" severity="secondary"
                                                        ripple="false" (onClick)="openFilterPopover(productPanel, $event)"
                                                        aria-label="Apply Filter">
                                                    </p-button>

                                                    <!-- Overlay panel -->
                                                    <p-popover #productPanel appendTo="body" [dismissable]="true"
                                                        styleClass="p-0 min-w-16 max-w-16 popover-content-p-0">

                                                        <!-- Content -->
                                                        <div class="py-10 px-12">
                                                            

                                                            <div>
                                                                <label class="form-label fs-12">
                                                                    {{ 'new_edit_master_plan.job_import_panel.label.select_products' | t }}
                                                                </label>

                                                                <p-multiSelect [(ngModel)]="selectedOptions"
                                                                    [options]="products" optionLabel="name"
                                                                    placeholder=" {{ 'new_edit_master_plan.job_import_panel.placeholder.select_products' | t }}"
                                                                    styleClass="w-100 p-multiselect-sm"
                                                                    panelStyleClass="p-multiselect-panel-sm"
                                                                    (onChange)="onOptionSelected($event)"
                                                                    [displaySelectedLabel]="true">

                                                                    <!-- Custom selected items template -->
                                                                    <ng-template pTemplate="selectedItems">
                                                                        <ng-container
                                                                            *ngIf="selectedOptions.length === 0">
                                                                            <span>{{ 'new_edit_master_plan.job_import_panel.label.select_products' | t }}</span>
                                                                        </ng-container>

                                                                        <ng-container *ngIf="selectedOptions.length">
                                                                            <div class="bg-gray-300 px-12 rounded-px-4 height-px-24 d-flex align-items-center"
                                                                                *ngFor="let option of selectedOptions.slice(0, 1)">
                                                                                <span class="fs-12 color-gray-800">
                                                                                    {{ option.name }}
                                                                                </span>
                                                                            </div>

                                                                            <span class="fs-12 color-gray-800 ms-2"
                                                                                *ngIf="selectedOptions.length > 1">
                                                                                + {{ selectedOptions.length
                                                                                - 1 }} more…
                                                                            </span>
                                                                        </ng-container>
                                                                    </ng-template>

                                                                </p-multiSelect>
                                                            </div>
                                                        </div>

                                                        <!-- Footer -->
                                                        <div
                                                            class="d-flex align-items-center justify-content-end py-10 px-12 bg-gray-100 gap-2">

                                                            <p-button type="button"
                                                                variant="text" severity="secondary" size="small"
                                                                (onClick)="resetLocationFilterField('product'); productPanel.hide()"
                                                                label="{{ 'common.actions.buttons.reset' | t }}">
                                                            </p-button>

                                                            <p-button type="button"
                                                                size="small"
                                                                (onClick)="applyLocationsFilter(); productPanel.hide()"
                                                                label="{{ 'common.actions.buttons.apply' | t }}">
                                                            </p-button>

                                                        </div>

                                                    </p-popover>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="text-nowrap">Sequence</th>
                                        <th class="text-nowrap">Problem</th>
                                        <th class="text-nowrap">Problem Located At</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-job>
                                    <tr>
                                        <td class="text-center">
                                            <i class="fa fs-17 cursor-default"
                                                [ngClass]="[job.locationStatus == 1 ? 'fa-times-circle color-danger-600':'', job.locationStatus == 2 ? 'fa-check-circle color-warning-300':'', job.locationStatus == 3 ? 'fa-check-circle color-success-500':'']"></i>
                                        </td>
                                        <td>{{ job.jobId }}</td>
                                        <td>{{ job.locationId }}</td>
                                        <td>
                                            <div *ngIf="job.locationName else noLocation">
                                                <div class="fw-semibold color-gray-800 mb-1">{{
                                                    job.locationName }}</div>
                                                <div class="mb-1">{{ job.address }}</div>
                                                <div class="mb-1">{{ job.postalCode }} - {{ job.city }}
                                                </div>
                                                <div class="mb-1">{{ job.country }}</div>
                                            </div>
                                            <ng-template #noLocation>
                                                --
                                            </ng-template>
                                        </td>
                                        <td>{{ job.serviceFromTime }} - {{ job.serviceToTime }}</td>
                                        <td>{{ job.productName }}</td>
                                        <td>{{ job.sequenceNumber || '--' }}</td>
                                        <td>{{ job.problem }}</td>
                                        <td>{{ job.problemLocatedAt }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <div class="empty-state grid">
                                        <div class="illustration">
                                            <svg class="width-11 height-8">
                                                <use xlink:href="#empty-state-file"></use>
                                            </svg>
                                        </div>

                                        <p class="fs-16 color-gray-900 p-0">
                                            No record found!
                                        </p>
                                    </div>
                                </ng-template>
                            </p-table>
                            </div>
                        </ng-container>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
        <ng-template #importJobScreen>
            <div class="vh-267 d-flex flex-column justify-content-center align-items-center">
                <div class="min-w-30">
                    <p class="fs-16 mb-4 fw-semibold color-gray-900">{{
                                'master_plans.job_import_panel.page.messages.importing' | t: {jobsCount:
                                jobsCount, locationCount: locationCount} }}</p>
                    <p-progressBar [value]="progressBarValue" class="d-block w-100"
                        styleClass="height-px-8 rounded-pill position-relative p-progressbar-label-none d-block p-progress-primary"></p-progressBar>
                    <p class="fs-15 mb-0 fw-regular color-gray-800">{{
                                'master_plans.job_import_panel.page.messages.please_wait' | t }}</p>
                </div>
            </div>
        </ng-template>

        <div class="card-footer justify-content-end border-top-0 gap-2" [ngClass]="{'d-none': activeIndex == 3}">
            <p-button label="Cancel" variant="outlined" styleClass="p-button-tertiary"
                (onClick)="discardChanges()"></p-button>
            <p-button label="{{ activeIndex == 0 ? 'Next': 'Import'}}"
                [ngClass]="{'disabled': (activeIndex!=0 && jobsCount===0) }"
                (onClick)="activeIndex == 0 ? moveIndex(1) : jobsCount>0?importJobs():handleNoJobs()"></p-button>
            <!-- <button type="button" class="btn btn-sm btn-primary px-30">
                        Save & Next
                    </button> -->
        </div>
    </div>
</div>